module.exports = {
  Days: 'День',
  Weeks: 'Неделя',
  Months: 'Месяц',
  CurrentlySelected: '(Текущий выбор)',
  CurrentPage: '(Текущая страница)',
  NonTicketSettlement: 'Без билетного расчета',
  TicketSettlement: 'Билетный расчет',
  MonthlySettlement: 'Месячный расчет',
  WeeklySettlement: 'Недельный расчет',
  Monthly: 'Ежемесячно',
  Day: 'День',
  CreditControl: 'Контроль кредита',
  All: 'Все',
  PleaseSelectAPartner: 'Пожалуйста, выберите партнера.',
  InvoiceDate: 'Дата счета-фактуры',
  BusinessDate: 'Дата операции',
  BillingDate: 'Дата счета',
  CostFinancialDate: 'Финансовая дата расходов',
  System: 'Система',
  PleaseASpecialApprovalBusiness: 'Пожалуйста, выберите специально утвержденную операцию',
  SpecialApprovalSuccessful: 'Специальное утверждение успешно',
  CancelledSpecialApprovalSuccessful: 'Отмена специального утверждения успешно',
  OceanShipping: 'Морская перевозка',
  PleaseFillInTheContact: 'Пожалуйста, укажите контактное лицо!',
  Other: 'Другое',
  CustomerType: 'Тип клиента',
  CustomerContactChannel: 'Канал взаимодействия с клиентом',
  DueBePrintedOrNeeded: 'Из-за превышения кредитного контроля данный билет заблокирован и не может быть распечатан или передан через EDI. Пожалуйста, свяжитесь с руководством для разблокировки при необходимости!',
  DearCustomersAssociatedWith: 'Дорогой, можно выбрать только клиентов, связанных с продажами (⊙o⊙)',
  CharacterTooLongPleaseAgain: 'Превышена длина символов, пожалуйста, исправьте!',
  ShippingTypeCannotBeEmpty: 'Тип транспортировки не может быть пустым',
  FullhalfJourneyCannotBeEmpty: 'Полный/половинный маршрут не может быть пустым',
  RouteCannotBeEmpty: 'Маршрут не может быть пустым',
  PleaseAPieceOfData: 'Пожалуйста, выберите одну запись!',
  OverdueFees: 'Просроченные расходы',
  OverControllAccountReceivable: 'Объект расчета с превышением кредитного контроля (дебиторская задолженность)',
  Family: 'Дом',
  CRMExpiredTip: 'Уважаемый пользователь, срок действия приобретенного вами модуля CRM истек.<br>Пожалуйста, продлите подписку для продолжения использования, вы можете связаться с вашим продавцом или службой поддержки.<br><div style="margin-top: 5px;">Доступ к модулю CRM будет ограничен, данные сохранятся. После продления подписки вы сможете снова им пользоваться.</div>',
  Barge: 'Баржа',
  SalesInquiryListPage: 'Страница списка запросов по продажам',
  RemoteBookingListPage: 'Страница списка удаленных бронирований'
}
